import { rem } from '@nobia/zeus-components/lib/styled'

export default {
  typography: {
    pageTitle: {
      fontSize: rem(30),
      fontSizeDesktop: rem(30),
      textTransform: 'uppercase',
      fontWeight: '700',
    },
  },
}
